export default "__VITE_ASSET__cua9_Ll5__"